<template>
  <div id="s1" v-scroll-container:backTop1
    class="view-wrapper view-wrapper-with-header view-wrapper-with-footer view-wrapper-h">
    <van-search v-model="value" placeholder="请输入搜索关键词" readonly shape="round" class="fixed-top" @click="goSearch">
      <!-- <van-icon slot="action" name="contact" size="18px" /> -->
    </van-search>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="pull-content">
      <!-- 轮播图 -->
      <div v-if="swipeList.length > 0">
        <van-swipe :autoplay="4000">
          <template v-for="(item, index) in swipeList">
            <van-swipe-item :key="index" v-if="item.PictureUrl">
              <a :href="item.PathUrl">
                <img v-lazy="item.PictureUrl" :to="item.PathUrl" />
              </a>
            </van-swipe-item>
          </template>
        </van-swipe>
      </div>
      <div class="nav-box" v-if="setting.HomeCategory">
        <router-link :to="{
          path: 'search_category',
          query: { pcId: cat.Id, categoryId: 0 },
        }" class="nav-box-item" v-for="cat in category" :key="cat.Id">
          <img :src="cat.PictureUrl" />
          <span>{{ cat.Name }}</span>
        </router-link>
      </div>
      <div>
        <template v-for="(item, idx) in subjects">
          <SubjectItem v-if="idx < setting.HomeSubjectCount" :key="item.Id" :subject="item" style="margin-bottom:10px;">
          </SubjectItem>
        </template>
      </div>
      <!-- <div class="divider-t">精选好物</div> -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="order-list">
        <!-- <ProductItem
          v-for="item in list"
          :key="'p' + item.ProId"
          :product="item"
        ></ProductItem> -->

        <div class="product-list">
          <div class="product-item" v-for="(item, index) in list" :key="item.ProId"
            :class="[index % 2 === 0 ? 'item-l' : 'item-r']">
            <ProductItemBox :product="item"></ProductItemBox>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <Tabbar></Tabbar>
    <BackToTop ref="backTop1"></BackToTop>
  </div>
</template>

<script>
// @ is an alias to /src
//import ProductItem from "@/components/ProductItem.vue";
import ProductItemBox from "@/components/ProductItemBox.vue";
import SubjectItem from "@/components/SubjectItem.vue";
import Tabbar from "@/components/Tabbar.vue";
import BackToTop from "@/components/BackToTop.vue"
import { getUserCartProdCount } from "@/api/account";

// import { Dialog } from "vant";

export default {
  name: "home",
  data () {
    return {
      value: "",
      size: 10,
      page: 1,
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      setting: {},
      subjects: [],
      category: [],
      swipeList: []
    };
  },
  components: {
    Tabbar,
    //ProductItem,
    SubjectItem,
    ProductItemBox,
    BackToTop
  },
  created () {
    this.loadHomeSetting();
    this.loadCategory();
    this.loadSwipeList();
    this.loadSubjectList();
    getUserCartProdCount();
  },
  methods: {
    onRefresh () {
      this.page = 1;
      this.finished = false;
      this.loadProduct();
      //console.log("下拉");
    },
    loadCategory () {
      //加载专题商品信息
      this.$ajax.get("api/product/home/categories").then((response) => {
        if (response.data.code === 1) {
          let data = response.data.data;
          this.category = data;
        }
      });
    },
    /**
     * 加载专题商品信息
     */
    loadSubjectList () {
      //加载专题商品信息
      this.$ajax
        .get("api/subject/home", {
          params: {
            source: this.$store.getters.source,
            size: 5,
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            let data = response.data.data;
            this.subjects = data;
          }
        });
    },

    /**
     * 加载轮播列表
     *
     * 通过 AJAX 请求从服务器获取首页的轮播列表数据，并将其保存到组件的 swipeList 属性中。
     */
    loadSwipeList () {
      this.$ajax
        .get("api/subject/swipe", {
          params: {
            source: this.$store.getters.source
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            let data = response.data.data;
            this.swipeList = data;
          }
        });
    },


    /**
     * 加载页面配置
     */
    loadHomeSetting () {
      //加载专题商品信息
      this.$ajax
        .get("api/content/setting", {
          params: {
            source: this.$store.getters.source
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            let data = response.data.data;
            this.setting = data;
            this.$store.dispatch("setSetting", response.data.data);
          }
        });
    },

    loadProduct () {
      //加载商品信息
      this.$ajax
        .get("api/product", {
          params: {
            page: this.page,
            size: this.size,
            source: this.$store.getters.source,
          },
        })
        .then((response) => {
          this.loading = false;
          this.isLoading = false;
          if (response.data.code === 1) {
            let data = response.data.data;

            if (data.length === 0 || data.length < this.size) {
              this.finished = true;
              //console.log("完成");
            }
            if (this.page === 1) {
              this.list = response.data.data;
            } else {
              this.list = this.list.concat(data);
            }
            this.page++; //增加页码
          }
          //this.finished = true;
        });
    },
    onLoad () {
      // 异步更新数据
      //console.log("list 加载");
      // var url = window.location.href;
      // var param = url.substring(url.indexOf("?"));
      // var redirectUrl = "https://bank.daeyes.com.cn/index.html" + param;

      //  Dialog.confirm({
      //     title: "跳转",
      //     message: url
      //   })
      //     .then(() => {
      //       //
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // console.log(param);
      // console.log(window.location.href);
      // Dialog.confirm({
      //   title: "跳转",
      //   message: redirectUrl
      // })
      //   .then(() => {
      //     window.location.href = redirectUrl;
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
      if (!this.isLoading) {
        this.loadProduct();
      }
    },
    goSearch () {
      this.$router.push({ path: "search", query: { from: "home" } });
    },
  },
};
</script>

<style lang="less" scoped>
.nav-box {
  background-color: #fff;
  padding: 10px 0 5px 0;
  margin-bottom: 10px;
  width: 100%;
  position: relative;
}

.nav-box::after {
  content: "";
  display: table;
  clear: both;
}

.nav-box-item {
  position: relative;
  width: 20%;
  display: block;
  text-align: center;
  float: left;
  margin-bottom: 10px;

  span {
    display: block;
    margin-top: 4px;
    font-size: 14px;
  }

  img {
    width: 60%;
  }
}

.divider-t {
  text-align: center;
  padding: 10px 15px 15px 15px;
  font-weight: bold;
  font-size: 18px;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;

  .product-item {
    width: 50%;
    box-sizing: border-box;
    padding: 0 10px 10px 10px;
  }

  .item-l {
    padding-right: 5px;
  }

  .item-r {
    padding-left: 5px;
  }
}
</style>
